/* eslint-disable */
__webpack_public_path__ = (function() {
  if (window.domainFromOptimizely_billing_common) {
    return resolve(window.domainFromOptimizely_billing_common, 'fe-billing-common/');
  } else if (window.domainFromServer) {
    return resolve(window.domainFromServer, 'fe-billing-common/');
  } else {
    return 'https://localhost:8091/'
  }
})()

function resolve(a, b) {
  if (!a) {
    return '';
  }
  if (a[a.length - 1] === '/') {
    return a + b;
  } else {
    return a + '/' + b;
  }
}
